(function () {
    'use strict';

    angular.module("imApp").factory("metaTablesService", ['$ihttp', function ($ihttp) {
        let service = {
            listMetaTables: function (parms) {
                return $ihttp.post({
                    method: 2371,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
